module.exports = __webpack_public_path__ + "images/thumbs-down-outlinec1dc2a04709d04094ec08b2121b89986.svg";